import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Product from '../views/Product.vue'
import Service from '../views/Service.vue'
import Download from '../views/Download.vue'
import About from '../views/About.vue'
import Join from '../views/Join.vue'
import JobApply from '../views/JobApply.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/product',
    name: 'Product',
    component: Product
  },
  {
    path: '/service',
    name: 'Service',
    component: Service
  },
  {
    path: '/download',
    name: 'Download',
    component: Download
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    // 加入我们：热招岗位列表页；投递表单页为 /join/apply?job=岗位id（见 JobApply）
    path: '/join',
    name: 'Join',
    component: Join
  },
  {
    path: '/join/apply',
    name: 'JobApply',
    component: JobApply
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  // 路由切换后滚动到页面顶部，保证进入各页都从模块一开始；
  // 带 ?to= 参数时（页脚链接指定模块）不落顶，由目标页自行滚到对应模块
  scrollBehavior(to) {
    if (to.query.to) {
      return
    }
    return { x: 0, y: 0 }
  }
})

export default router
